import React from "react";

type Props = {
  fill?: string;
};

const AlarmClockOutline = ({ fill = "#1581BA" }: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1032_936"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1032_936)">
      <path
        d="M8.00003 14.4003C7.22226 14.4003 6.49375 14.2525 5.81453 13.957C5.1352 13.6614 4.54409 13.2622 4.0412 12.7592C3.5382 12.2563 3.13892 11.6652 2.84337 10.9858C2.54781 10.3066 2.40003 9.5781 2.40003 8.80033C2.40003 8.02255 2.54781 7.29405 2.84337 6.61483C3.13892 5.93549 3.5382 5.34438 4.0412 4.84149C4.54409 4.33849 5.1352 3.93921 5.81453 3.64366C6.49375 3.3481 7.22226 3.20033 8.00003 3.20033C8.77781 3.20033 9.50631 3.3481 10.1855 3.64366C10.8649 3.93921 11.456 4.33849 11.9589 4.84149C12.4619 5.34438 12.8611 5.93549 13.1567 6.61483C13.4523 7.29405 13.6 8.02255 13.6 8.80033C13.6 9.5781 13.4523 10.3066 13.1567 10.9858C12.8611 11.6652 12.4619 12.2563 11.9589 12.7592C11.456 13.2622 10.8649 13.6614 10.1855 13.957C9.50631 14.2525 8.77781 14.4003 8.00003 14.4003ZM9.6667 11.067L10.5167 10.217L8.60003 8.30033V5.60033H7.40003V8.80033L9.6667 11.067ZM3.95003 1.91699L4.80003 2.76699L1.9667 5.60033L1.1167 4.75033L3.95003 1.91699ZM12.05 1.91699L14.8834 4.75033L14.0334 5.60033L11.2 2.76699L12.05 1.91699ZM7.99637 13.2003C9.22103 13.2003 10.2611 12.7738 11.1167 11.9207C11.9723 11.0675 12.4 10.0287 12.4 8.80399C12.4 7.57933 11.9735 6.53921 11.1204 5.68366C10.2673 4.8281 9.22837 4.40033 8.0037 4.40033C6.77903 4.40033 5.73892 4.82688 4.88337 5.67999C4.02781 6.5331 3.60003 7.57199 3.60003 8.79666C3.60003 10.0213 4.02659 11.0614 4.8797 11.917C5.73281 12.7725 6.7717 13.2003 7.99637 13.2003Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default AlarmClockOutline;
